module.exports = __webpack_public_path__ + "img/icon-success.6b68b3be.png";